/* eslint-disable */
export default {
  matched: '일치함',
  other: '기타',
  associated: '연결됨',
  foundFromServer: '{appName}에서 찾음',
  recently: '최근',
  additionalLabelAccount: '계정: {displayName}',
  additionalLabelContact: '연락처: {displayName}',
  notFound: '해당 없음',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
